import { AlertTriangle, Download, Shield, ShieldAlert } from "lucide-react";
import { CTAButton } from "../shared/CTAButton";
const HeroClean = () => {
  const scrollToForm = () => {
    const formElement = document.getElementById('lead-form');
    formElement?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const stats = [{
    value: "500+",
    label: "Downloads"
  }, {
    value: "4.8",
    label: "Bewertung"
  }, {
    value: "98%",
    label: "Empfehlung"
  }, {
    value: "< 2 Min",
    label: "Setup"
  }];
  return <section className="py-20 sm:py-28 lg:py-32">
      <div className="container max-w-7xl mx-auto px-6 sm:px-8">
        
        {/* HERO CONTENT - ZENTRIERT */}
        <div className="max-w-5xl mx-auto text-center">
          
          {/* 1. BADGE - zentriert */}
          <div className="flex justify-center mb-8">
            <div className="inline-flex items-center gap-2 border border-destructive/30 px-4 py-2 rounded-full">
              <AlertTriangle className="w-4 h-4 text-destructive" />
              <span className="text-xs font-semibold text-destructive uppercase tracking-wide">
                CYBER-ALARM
              </span>
            </div>
          </div>
          
          {/* 2. H1 - zentriert, optimierte Größen */}
          <h1 className="mb-8">
            <span className="block text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-bold text-destructive mb-4 leading-none">
              CYBERALARM
            </span>
            <span className="block text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-light text-foreground/90 leading-tight">
              in Deutschland
            </span>
          </h1>
          
          {/* 3. SUBTEXT - zentriert, optimierte Line-Height */}
          <div className="space-y-6 mb-12 max-w-3xl mx-auto">
            <p className="text-xl sm:text-2xl md:text-3xl text-foreground/80 leading-relaxed">
              Datenklau, Millionenverlust und Reputationsschaden durch Cyberangriffe!
            </p>
            <p className="text-2xl sm:text-3xl text-foreground font-bold leading-tight text-center md:text-base">
              ⚠️ Wie sicher sind Ihre Patientendaten wirklich?
            </p>
          </div>
          
          {/* 4. CTA BUTTON - zentriert */}
          <div className="flex justify-center mb-8">
            <CTAButton onClick={scrollToForm} icon={Download} className="text-lg sm:text-xl px-12 py-5">
              Checkliste kostenlos sichern
            </CTAButton>
          </div>
          
          {/* 5. TRUST BADGE - zentriert, eigene Zeile */}
          <div className="flex items-center justify-center gap-3 text-lg sm:text-xl text-muted-foreground">
            <Shield className="w-6 h-6 text-accent" />
            <span>
              Bereits von über <strong className="text-foreground">500+</strong> Praxen genutzt
            </span>
          </div>
        </div>
        
        {/* STATS BAR - mehr Abstand, zentriert */}
        <div className="mt-20 sm:mt-24 lg:mt-28">
          <div className="max-w-5xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-8 border border-white/10 rounded-2xl p-6 sm:p-8 backdrop-blur-sm">
            {stats.map((stat, idx) => <div key={idx} className="text-center">
                <div className="text-3xl sm:text-4xl lg:text-5xl font-bold text-accent mb-2">
                  {stat.value}
                </div>
                <div className="text-sm sm:text-base text-muted-foreground uppercase tracking-wide">
                  {stat.label}
                </div>
              </div>)}
          </div>
        </div>
        
      </div>
    </section>;
};
export default HeroClean;